export default "__VITE_ASSET__CsuJzul___"